import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { FIRST_PAGE, MAX_PER_PAGE } from 'constants/constants';
import { PurchaseOrderPage, QueryPurchaseOrdersArgs } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryPurchaseOrdersArgs;
type TData = PurchaseOrderPage;

const MOCK: TVariables = {
  page: FIRST_PAGE,
  perPage: MAX_PER_PAGE,
  skipPagination: undefined,
  sortAttribute: undefined,
  sortOrder: undefined
};

export const useOrders = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query orders(
      $sortAttribute: PurchaseOrderSortAttributeEnum
      $sortOrder: SortOrderEnum
      $page: Int
      $perPage: Int
    ) {
      purchaseOrders(
        sortAttribute: $sortAttribute
        sortOrder: $sortOrder
        page: $page
        perPage: $perPage
      ) {
        nodes {
          id
          paymentStatus
          price
          orders {
            id
            translationRequest {
              id
              version
              title
              sourceLanguageCode
              targetLanguageCode
            }
            totalOrderedWordCount
            quality
            price
            currency
          }
          price
          currency
          createdAt
        }
        nodesCount
        pagesCount
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['orders', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () =>
      await client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
